import { render, staticRenderFns } from "./statistic.vue?vue&type=template&id=bfc74ddc&"
import script from "./statistic.vue?vue&type=script&lang=ts&"
export * from "./statistic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports